import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../../config/api';
import { DataService } from '../../config/dataService/dataService';
import { buildQueryStringForRecordPayment, paramsToQueryString } from '../../utility/helpers/commonFunction';
import { USER_TIMEZONE } from '../../utility/Constant';

// Personal details fetch
export const invoiceListing = (
    pages,
    limit,
    status,
    sortType,
    sortBy,
    licenseNumber,
    fleetUnitNumber,
    year,
    makeId,
    modelId,
    date,
    search,
    customer,
    paymentStatus,
    provinceId,
    vin
) => {
    return async (dispatch) => {
        try {
            const params = new URLSearchParams({
                page: pages,
                limit,
                status,
                sortType,
                sortBy,
                timezone: (USER_TIMEZONE || '').trim(),
            });

            if (makeId) params.append('vehicleMakeId', makeId);
            if (modelId) params.append('vehicleModelId', modelId);
            if (year) params.append('vehicleYear', year);
            if (date) params.append('date', date);
            if (search) params.append('searchText', search);
            if (customer) params.append('customer', customer);
            if (licenseNumber) params.append('licenseNumber', licenseNumber);
            if (fleetUnitNumber) params.append('fleetUnitNumber', fleetUnitNumber);
            if (provinceId) params.append('provinceId', provinceId);
            if (vin) params.append('vin', vin);

            if (paymentStatus && paymentStatus.length > 0) {
                paymentStatus.forEach((status) => {
                    params.append('paymentStatus', status);
                });
            }

            const response = await DataService.get(`${API.invoice.invoiceList}?${params.toString()}`);
            if (!response.data.error) {
                dispatch({
                    type: API.invoice.invoiceList,
                    InvoiceData: response.data,
                    loading: false,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const customerWithAppointment = (pages, limit, customerSearch) => {
    return async (dispatch) => {
        let queryParamter = `?page=${pages}&limit=${limit}`;
        if (customerSearch) {
            queryParamter += `&searchText=${customerSearch}`;
        }
        try {
            const response = await DataService.get(`${API.invoice.getCustomerList}` + queryParamter);
            if (!response.data.error) {
                console.log('🚀 ~ file: action.js:54 ~ return ~ response.data:', response.data);
                dispatch({
                    type: API.invoice.getCustomerList,
                    getCustomerList: response.data.data,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const vehicleList = () => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(`${API.invoice.vehicleList}`);
            if (!response.data.error) {
                dispatch({
                    type: API.invoice.vehicleList,
                    vehicleList: response.data.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const invoiceDetails = (id) => {
    return async (dispatch) => {
        try {
            const response = await DataService.get(`${API.invoice.invoiceDetails}/${id}`);
            if (!response.data.error) {
                dispatch({
                    type: API.invoice.invoiceDetails,
                    invoiceDetails: response.data.data,
                    loading: false,
                });
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const createNewInvoice = (params, payload) => async (dispatch) => {
    try {
        const queryString = paramsToQueryString(params);
        const response = await DataService.post(API.invoice.create + queryString, payload);
        if (response.data.status) {
            dispatch({
                type: API.invoice.create,
                shopInfoData: response.data.data,
                loading: false,
            });

            // saved, but the PDF failed (and any requested email was held back)
            if (response.data.data?.pdfWarning) toast.warning(response.data.data.pdfWarning, { duration: 10000 });

            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const updateFinalizeInvoice = (id, params, payload) => async (dispatch) => {
    try {
        const queryString = paramsToQueryString(params);
        const response = await DataService.put(API.invoice.updateFinalizeInvoice + id + queryString, payload);
        if (response.data.status) {
            dispatch({
                type: API.invoice.create,
                shopInfoData: response.data.data,
                loading: false,
            });

            // saved, but the PDF failed (and any requested email was held back)
            if (response.data.data?.pdfWarning) toast.warning(response.data.data.pdfWarning, { duration: 10000 });

            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const updateInvoiceRecordPayments = (id, params, payload) => async (dispatch) => {
    try {
        const queryString = paramsToQueryString(params);
        const response = await DataService.put(API.invoice.recordPayments + id + queryString, payload);
        if (response.data.status) {
            dispatch({
                type: API.invoice.create,
                shopInfoData: response.data.data,
                loading: false,
            });

            // saved, but the PDF failed (and any requested email was held back)
            if (response.data.data?.pdfWarning) toast.warning(response.data.data.pdfWarning, { duration: 10000 });

            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const createNewInvoiceDraft = (params, payload) => async (dispatch) => {
    try {
        const response = await DataService.post(API.invoice.createDraft, payload);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const customersList = () => async (dispatch) => {
    try {
        const response = await DataService.get(`${API.invoice.customerList}`);
        if (response.data.status) {
            dispatch({
                type: API.invoice.customerList,
                customerList: response.data,
                loading: false,
            });

            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const AllCustomersList = (page, limit, customerSearch) => async (dispatch) => {
    let queryParamter = `?page=${page}&limit=${limit}`;
    if (customerSearch) {
        queryParamter += `&searchText=${customerSearch}`;
    }
    try {
        const response = await DataService.get(`${API.customer.allCustomerList}` + queryParamter);
        if (response.data.status) {
            dispatch({
                type: API.invoice.customerList,
                customerList: response.data,
                loading: false,
            });

            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const CustomersListBasedOnType = (customerSearch, customerType, pages, limit, cancelToken) => async (dispatch) => {
    let queryParamter;
    let queryString;
    if (customerType.length > 0) {
        queryString = customerType.map((value) => `createdFrom=${value}`).join('&');
        queryParamter = `?${queryString}&page=${pages}&limit=${limit}`;
        // queryParamter = `?${queryString}&page=${pages}`;
    }

    if (customerSearch) {
        queryParamter += `&name=${encodeURIComponent(customerSearch)}`;
    }
    try {
        const response = await DataService.get(`${API.customer.customerListWithType}` + queryParamter, {}, cancelToken);
        if (response.data.status) {
            // dispatch({
            //   type: API.customer.customerListWithType,
            //   customerList: response.data,
            //   loading: false,
            // });
            return response.data;
        } else {
            return false;
        }
    } catch (error) {
        if (axios.isCancel(error)) {
            return false;
        }
        return false;
    }
};

export const customerDetailsBasedOnType = (id) => async (dispatch) => {
    try {
        const response = await DataService.get(`${API.customer.customerDetilsWithType}/${id}`);
        if (response.data.status) {
            return response.data.data;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};

export const deleteInvoice = (id) => async (dispatch) => {
    try {
        const response = await DataService.delete(API.invoice.deleteDraft + '/' + id);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch (error) {
        return false;
    }
};
export const sendInvoice = (invoiceId) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(`${API.invoice.sentInvoiceDetails}/${invoiceId}`);
            // failures are already shown by the response interceptor
            if (response?.data?.status) {
                return response.data.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const downloadReport = (payload) => async (dispatch) => {
    try {
        // errors (no data, PDF failed, timeout) are shown by the response interceptor with the server's message
        return await DataService.post(API.invoice.downloadInvoiceSalesReport, payload, {}, 'arraybuffer');
    } catch (error) {
        return false;
    }
};

export const downloadAccountRecievableReport = (payload) => async (dispatch) => {
    try {
        // errors (no data, PDF failed, timeout) are shown by the response interceptor with the server's message
        return await DataService.post(API.invoice.downloadAccountReceivableReport, payload, {}, 'arraybuffer');
    } catch (error) {
        return false;
    }
};

export const downloadStatementOfAccountReport = (payload) => async (dispatch) => {
    try {
        // errors (no data, PDF failed, timeout) are shown by the response interceptor with the server's message
        return await DataService.post(API.invoice.downloadStatementOfAccountReport, payload, {}, 'arraybuffer');
    } catch (error) {
        return false;
    }
};

export const getAdvisorListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.advisor.get + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.advisor.get,
                    advisorList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addAdvisorApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.advisor.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updateAdvisorApi = async (id, payload) => {
    try {
        // Backend expects partial updates for these resources.
        const response = await DataService.put(API.inventory.advisor.update + id, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const deleteAdvisorApi = async (id) => {
    try {
        const response = await DataService.delete(API.inventory.advisor.delete + id);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const getTechnicianListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.inventory.technician.get + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.inventory.technician.get,
                    technicianList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addTechnicianApi = async (payload) => {
    try {
        const response = await DataService.post(API.inventory.technician.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updateTechnicianApi = async (id, payload) => {
    try {
        // Backend expects partial updates for these resources.
        const response = await DataService.put(API.inventory.technician.update + id, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};
export const deleteTechnicianApi = async (id, payload) => {
    try {
        const response = await DataService.delete(API.inventory.technician.delete + id);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

//Fees CRUD
export const getInvoiceFeesListApi = (params) => {
    return async (dispatch) => {
        try {
            let queryString = paramsToQueryString(params);
            const response = await DataService.get(API.invoice.fees.list + queryString);
            if (!response.data.error) {
                dispatch({
                    type: API.invoice.fees.list,
                    feesList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch {
            return false;
        }
    };
};

export const addInvoiceFeesApi = async (payload) => {
    try {
        const response = await DataService.post(API.invoice.fees.create, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const updateInvoiceFeesApi = async (id, payload) => {
    try {
        const response = await DataService.put(API.invoice.fees.update + id, payload);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const deleteInvoiceFeesApi = async (id) => {
    try {
        const response = await DataService.delete(API.invoice.fees.delete + id);
        if (!response.data.error) {
            return response.data;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

export const deleteFinalizedInvoice = async (id) => {
    try {
        const response = await DataService.delete(API.invoice.finalizedDelete + id);
        if (response.data.status) {
            return true;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

// Record payment modal API
export const multipleRecordPaymentListApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = buildQueryStringForRecordPayment(params);
            const response = await DataService.get(API.invoice.multipleRecordPayment.list + queryString);
            if (response.data.status) {
                dispatch({
                    type: API.invoice.multipleRecordPayment.list,
                    multipleRecordPaymentList: response.data,
                });
                return response.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
// Record payment modal API
export const bulkUpdateRecordPaymentApi = (payload) => {
    return async (dispatch) => {
        try {
            const response = await DataService.put(API.invoice.multipleRecordPayment.bulkUpdate, payload, {}, payload.isExport && 'arraybuffer');
            if (response) {
                if (response.data.status) {
                    toast.success(response?.data?.message);
                    return response.data;
                } else {
                    return response;
                }
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

// Record payment modal API
export const UpdateExportRecordPaymentApi = (payload) => {
    return async (dispatch) => {
        try {
            const response = await DataService.post(API.invoice.multipleRecordPayment.exportUpdate, payload, {}, 'arraybuffer');
            if (response) {
                if (response.data.status) {
                    toast.success(response?.data?.message);
                    return response.data;
                } else {
                    return response;
                }
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const customerListRecordApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = '?limit=5000&page=1&createdFrom=shop_created';
            const response = await DataService.get(API.invoice.multipleRecordPayment.customer + queryString);
            if (response.data.status) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
export const companyListRecordApi = (params) => {
    return async (dispatch) => {
        try {
            const queryString = '?limit=5000&page=1&createdFrom=shop_created';
            const response = await DataService.get(API.invoice.multipleRecordPayment.compnay + queryString);
            if (response.data.status) {
                return response.data?.data;
            } else {
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};
